import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    marginTop: theme.spacing.space12,
  },
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: theme.colors.background6,
    padding: theme.spacing.space12,
    borderRadius: theme.radius.small,
  },
  leftContent: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space12,
  },
  arrow: {
    fontSize: "18px !important",
  },
}));
